import { pacificblue, pacificblueLight } from '/b2b/common/colors';

import { MAX_CHAT_WIDTH } from '../../../../constants';
import { darken } from '@mui/material';

export default theme => ({
    root: {
        flex: '1 1 auto',
        overflowY: 'auto',
        padding: theme.spacing(2),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    messages: {
        width: '100%',
        maxWidth: MAX_CHAT_WIDTH,
    },
    empty: {
        flex: '1 1 auto',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: theme.spacing(1),
        padding: theme.spacing(4),
    },
    logo: {
        fontSize: '3rem',
        marginBottom: theme.spacing(1),
    },
    loadEarlierWrapper: {
        display: 'flex',
        justifyContent: 'center',
        padding: theme.spacing(1, 0, 2),
    },
    escalationMarker: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(2),
        margin: theme.spacing(3, 0),
    },
    escalationMarkerLine: {
        flex: 1,
        height: 1,
        backgroundColor: theme.palette.divider,
    },
    escalationMarkerContent: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.5),
        padding: theme.spacing(2, 2),
        backgroundColor: pacificblueLight,
        border: `1px solid ${darken(pacificblueLight, 0.1)}`,
        color: darken(pacificblue, 0.2),
        borderRadius: theme.shape.borderRadius,
        whiteSpace: 'nowrap',
    },
    systemNotice: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(2),
        margin: theme.spacing(3, 0),
    },
    systemNoticeLine: {
        flex: 1,
        height: 1,
        backgroundColor: theme.palette.divider,
    },
    systemNoticeText: {
        color: theme.palette.text.secondary,
        textAlign: 'center',
        maxWidth: '70%',
    },
    escalationMarkerLink: {
        color: 'inherit',
        display: 'flex',
        fontWeight: 600,
        textDecoration: 'underline',
    },
});
